import routeEventsEscl from '../locales/es-CL/routeEvents.json';
import routeEventsEsmx from '../locales/es-MX/routeEvents.json';
import routeEventsEsco from '../locales/es-CO/routeEvents.json';
import routeEventsEnus from '../locales/en-US/routeEvents.json';
import { EVENT } from '../constants/utils';
import Icon from '@/components/Icons';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import axios from 'axios';

export default {
  name: 'RouteEvents',
  components: { VueperSlides, VueperSlide, Icon },
  i18n: {
    messages: {
      'es-CL': {
        routeEvents: routeEventsEscl,
      },
      'es-MX': {
        routeEvents: routeEventsEsmx,
      },
      'es-CO': {
        routeEvents: routeEventsEsco,
      },
      'en-US': {
        routeEvents: routeEventsEnus,
      },
    },
  },
  data() {
    return {
      timeoutID: null,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 300,
      activeNotification: this.$store.getters.notificationConfig,
      activeSound: this.$store.getters.soundConfig,
      incomingEvents: null,
      isMainPageBussy: false,
      isFilterClicked: false,
      isFilterShown: false,
      isConfigShown: false,
      dataAccess: null,
      isFilterApplied: false,
      totalLastEvents: 5,
      dataEvents: null, //Lista data total proveniente del back de eventos
      totalTypes: [], //Lista eventos unicos
      lastEvents: [], //Lista ultimos eventos (15 minutos)
      lastEventsToday: [], //Lista eventos del día
      filters: {
        eventsSelected: null,
        multipleEventsFilter: [],
        totalTypeEvents: [],
        vehiclesSelected: null,
        totalVehicles: [],
      },
      //breakpoints significa cuando el ancho de la pantalla es del valor indicado se gatillan ciertas reglas
      breakpoints: {
        1100: {
          visibleSlides: 2,
        },
        600: {
          visibleSlides: 2,
          arrows: false,
          bulletsOutside: true,
        },
      },
      realNameType: [
        'Apertura de Puerta',
        'Detención Excesiva',
        'Exceso de Velocidad',
        'Exceso de Velocidad por Flota',
        'Desconexión Eléctrica',
        'Pérdida de Ubicación GPS',
        'Salida de Ruta',
        'Interferencia en Señal GPS',
        'Botón de Pánico activado',
      ],
      nameType: [
        'puertas',
        'detencion',
        'velocidad',
        'velocidadMaxima',
        'desconexion',
        'gps',
        'salidaDeRuta',
        'interferencia',
        'panico',
      ], //Lista de tipo de eventos reducida (Nombre abreviados para su mejor uso en las validaciones)
    };
  },
  async created() {
    this.isMainPageBussy = true;
    this.prepareData();
    this.isMainPageBussy = false;
    this.autoRefresh();
  },
  methods: {
    colores(eventType) {
      if (this.filters.eventsSelected != eventType) {
        return 'background-color: #F5F3FD;';
      } else {
        if (this.filters.multipleEventsFilter.length == 0) {
          return 'background-color: #E2DBFC;';
        }
      }
    },
    filterByEvent(eventType) {
      if (this.filters.eventsSelected != eventType) {
        this.filters.eventsSelected = eventType;
        this.filterEvents();
      } else {
        this.filters.eventsSelected = null;
        this.filterEvents();
      }
    },
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.dataEvents = await this.getAlerts();
      this.changeAlertTypes(this.dataEvents);
      this.loadUniqueEvents(this.dataEvents); //Carga el total de eventos por tipo de evento
      this.loadLastEvents(this.dataEvents); //Carga los listados de eventos
      this.populateVehiclesFilter();
      this.populateEventsFilter();
      this.isMainPageBussy = false;
    },
    async prepareRealData(event) {
      this.isMainPageBussy = true;
      this.dataEvents.push(event);
      this.loadUniqueEvents(this.dataEvents); //Carga el total de eventos por tipo de evento
      this.loadLastEvents(this.dataEvents); //Carga los listados de eventos
      this.isMainPageBussy = false;
    },
    async getAlerts() {
      const urlAlert = `${this.$store.getters.urlAPI}/alert`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const alertPromise = await axios.get(urlAlert, config);
        return alertPromise.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'Route events');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    populateVehiclesFilter() {
      this.filters.totalVehicles = [
        ...new Map(this.dataEvents.map((event) => [event['plate'], event['plate']])).values(),
      ];
    },
    populateEventsFilter() {
      this.totalTypes.forEach((eventType) => {
        let body = {
          nameType: eventType.name,
          numberType: eventType.numberType,
        };
        this.filters.totalTypeEvents.push(body);
      });
    },
    /**
     * Metodo que cambia el tipo de alerta a tipo de  evento  para laertas tipo jammer y panico
     * @param {*} infoTotalEvents
     */
    changeAlertTypes(infoTotalEvents) {
      infoTotalEvents.forEach((event) => {
        //Alerta de panico
        if (event.alertType == 102) {
          event.eventType = 109;
        }
        //Alerta de Jammer
        if (event.alertType == 103) {
          event.eventType = 108;
        }
      });
    },
    /**
     * Metodo que carga eventos (Soporta los filtros)
     * @param {*} infoTotalEvents
     */
    loadLastEvents(infoTotalEvents) {
      let infoSortEvents = infoTotalEvents.sort(function (a, b) {
        return b.initEvent - a.initEvent;
      });
      this.lastEvents = [];
      this.lastEventsToday = [];
      let seeEvents = [];

      let today = Date.now();
      let min15 = 900000; //15 minutos
      infoSortEvents.forEach((event) => {
        let bodyseeEvents = [
          event.plate ? event.plate : null,
          event.initEvent ? event.initEvent : null, // Inicio del evento
        ];
        let bodyEvent = {
          idVehicle: event.idVehicle ? event.idVehicle : null,
          initEvent: event.initEvent ? event.initEvent : null, // Inicio del evento
          address: event.address ? event.address : null,
          client: event.client ? event.client : null,
          idClient: event.idClient ? event.idClient : null,
          plate: event.plate ? event.plate : null,
          driver: event.driver ? event.driver : null,
          idAssignation: event.idAssignation ? event.idAssignation : null,
          idRoute: event.idRoute ? event.idRoute : null,
          idOrigin: event.idOrigin ? event.idOrigin : null,
          idDestination: event.idDestination ? event.idDestination : null,
          nameEvent: event.nameEvent ? event.nameEvent : null,
          nameRoute: event.nameRoute ? event.nameRoute : null,
          nameOrigin: event.nameOrigin ? event.nameOrigin : null,
          nameDestination: event.nameDestination ? event.nameDestination : null,
          eventType: event.eventType ? event.eventType : null,
          nameType: event.eventType ? this.getShortNameType(event.eventType - 101) : 'No existe',
          ignicion: event.ignicion ? event.ignicion : -1,
          lostTime: this.validateIncomingData(event.lostTime) ? event.lostTime : '-', //Para alertas de tipo 5 y 6
          lastConnection: event.lastConnection && event.lastConnection != 0 ? event.lastConnection : '-', //Para alertas de tipo 5 y 6
          electricPowerSupply: this.validateIncomingData(event.electricPowerSupply) ? event.electricPowerSupply : '-', //Para alertas de tipo 5 y 6
          endEvent: this.validateIncomingData(event.endEvent) ? event.endEvent : null, //Para alertas de tipo 1,2
          idOpenDoor: event.idOpenDoor, //Identificador de apertura de puerta
        };
        seeEvents.push(bodyseeEvents);
        //Se le asigna el nombreClave abreviado
        event.nameType = this.getShortNameType(event.eventType - 101);
        if (event.initEvent >= today - min15) {
          this.lastEvents.push(bodyEvent);
        } else {
          this.lastEventsToday.push(bodyEvent);
        }
      });
      localStorage.setItem('eventsCheck', seeEvents);
      console.log('list', this.lastEventsToday);
    },
    validateIncomingData(data) {
      return data != null && data != '' && data != undefined && data;
    },
    //Tipo de eventos existentes
    //(1) "Apertura de Puerta"
    //(2) "Detención Excesiva"
    //(3) "Exceso de Velocidad"
    //(4) "Exceso de Velocidad por Flota"
    //(5) "Desconexión Eléctrica"
    //(6) "Pérdida de Ubicación GPS"
    //(7) "Salida de Ruta"
    loadUniqueEvents(infoTotalEvents) {
      this.totalTypes = [];
      let eventDoor = 0;
      let eventDetention = 0;
      let eventSpeed = 0;
      let eventMaxSpeed = 0;
      let eventDisconnection = 0;
      let eventGps = 0;
      let eventOutOfRoute = 0;
      let eventInterference = 0;
      let eventPanic = 0;
      infoTotalEvents.forEach((event) => {
        //(1) "Apertura de Puerta"
        eventDoor = event.eventType == EVENT.APERTURA_PUERTA ? (eventDoor += 1) : eventDoor;
        //(2) "Detención Excesiva"
        eventDetention = event.eventType == EVENT.DETENCION_EXCESIVA ? (eventDetention += 1) : eventDetention;
        //(3) "Exceso de Velocidad"
        eventSpeed = event.eventType == EVENT.EXCESO_VELOCIDAD ? (eventSpeed += 1) : eventSpeed;
        //(4) "Exceso de Velocidad por Flota"
        eventMaxSpeed = event.eventType == EVENT.EXCESO_VELOCIDAD_FLOTA ? (eventMaxSpeed += 1) : eventMaxSpeed;
        //(5) "Desconexión Eléctrica"
        eventDisconnection = event.eventType == EVENT.DESCONEXION_ELECTRICA ? (eventDisconnection += 1) : eventDisconnection;
        //(6) "Pérdida de Ubicación GPS"
        eventGps = event.eventType == EVENT.PERDIDA_UBICACION_GPS ? (eventGps += 1) : eventGps;
        //(7) "Salida de Ruta"
        eventOutOfRoute = event.eventType == EVENT.SALIDA_RUTA ? (eventOutOfRoute += 1) : eventOutOfRoute;
        //(8) "Interferencia"
        eventInterference = event.eventType == EVENT.INTEREFERENCIA_GPS ? (eventInterference += 1) : eventInterference;
        //(9) "Panico"
        eventPanic = event.eventType == EVENT.BOTON_PANICO ? (eventPanic += 1) : eventPanic;
      });
      //Se pobla la lista de eventos unicos para conocer cuantos eventos existen por tipo
      let totalEventsOcurred = [
        eventDoor,
        eventDetention,
        eventSpeed,
        eventMaxSpeed,
        eventDisconnection,
        eventGps,
        eventOutOfRoute,
        eventInterference,
        eventPanic,
      ];
      for (let i = 0; i < totalEventsOcurred.length; i++) {
        this.totalTypes.push({
          name: this.realNameType[i],
          nameType: this.getShortNameType(i),
          numberType: i + 101,
          totalEvents: totalEventsOcurred[i],
        });
      }
    },
    filterEvents() {
      this.isFilterApplied = false;
      let tempEvents = this.dataEvents;
      if (this.filters.vehiclesSelected !== null) {
        tempEvents = tempEvents.filter((event) => {
          if (event.plate != null || event.plate != undefined) {
            return event.plate === this.filters.vehiclesSelected;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.eventsSelected !== null && this.filters.multipleEventsFilter.length == 0) {
        tempEvents = tempEvents.filter((event) => {
          if (event.eventType) {
            return event.eventType === this.filters.eventsSelected;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.multipleEventsFilter.length > 0) {
        this.filters.eventsSelected = null;
        tempEvents = tempEvents.filter((event) => {
          if (event.eventType != null || event.eventType != undefined) {
            return this.filters.multipleEventsFilter.some((selectEvent) => {
              if (selectEvent.numberType != undefined) {
                return event.eventType === selectEvent.numberType;
              }
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      this.loadLastEvents(tempEvents);
    },
    cleanFilter() {
      this.filters.multipleEventsFilter = [];
      this.filters.vehiclesSelected = null;
      this.filterEvents();
    },
    /**
     * Transforma el timestamp del inicio del evento al formato fecha dd/mm/yyyy y la hora en hh:mm
     * @param {*} dateTimeStamp
     * @returns
     */
    getDate(dateTimeStamp) {
      if (dateTimeStamp != '-' && dateTimeStamp != null) {
        let dateGMT = new Date(dateTimeStamp);
        let offset = dateGMT.getTimezoneOffset();
        let timeStampLocal = dateGMT - offset * 60000;
        let dateEvent = new Date(timeStampLocal).toISOString().split('T');
        let date = dateEvent[0].split('-');
        let dd = String(date[1]);
        let mm = String(date[2]); //January is 0!
        let yyyy = date[0];

        let hour = dateEvent[1].split(':');
        let hh = hour[0];
        let min = hour[1];

        dateEvent = mm + '/' + dd + '/' + yyyy;
        let hourEvent = hh + ':' + min;

        return [dateEvent, hourEvent];
      }
      return dateTimeStamp;
    },
    getHour(lostTime) {
      if (lostTime && lostTime != '-') {
        let duration = new Date(lostTime).toISOString().split('T');

        let hour = duration[1].split(':');
        let hh = hour[0];
        let min = hour[1];
        let sec = hour[2].split('.')[0];

        return hh + ':' + min + ':' + sec;
      }
      return '-';
    },
    /**
     * Metodo para calcular el tiempo que duro la estancia en la alerta "Detencion excesiva"
     * @param {*} startDate
     * @param {*} endDate
     * @returns
     */
    getDuration(startDate, endDate) {
      try {
        let duration = new Date(endDate - startDate).toISOString().split('T');

        let hour = duration[1].split(':');
        let hh = hour[0];
        let min = hour[1];
        let sec = hour[2].split('.')[0];

        duration = hh + ':' + min + ':' + sec;
        return duration;
      } catch (e) {
        console.log(e);
        return '-';
      }
    },
    /**
     * Consigue el nombre abreviado del evento
     * @param {*} typeEvent
     * @returns
     */
    getShortNameType(typeEvent) {
      return this.nameType[typeEvent];
    },
    /**
     * Consigue el nombre completo del tipo de evento en multiIdioma
     * @param {*} typeEvent
     * @returns
     */
    getNameEvent(typeEvent) {
      return this.$t(`routeEvents.eventTypesOptions[${typeEvent}]`);
    },
    getTitle(event) {
      return event.totalEvents + '  ' + this.$t('routeEvents.events');
    },
    getNameIgnition(stateIgnition) {
      return this.$t(`routeEvents.eventCards.stateIgnition[${stateIgnition}]`);
    },
    getNameElectricalFeed(electricalFeed) {
      let stateFeed = null;
      if (electricalFeed == 'DESCONECTADA') {
        stateFeed = this.$t(`routeEvents.eventCards.stateElectricalFeed.DESCONECTADA`);
      }
      if (electricalFeed == 'CONECTADA') {
        stateFeed = this.$t(`routeEvents.eventCards.stateElectricalFeed.CONECTADA`);
      } else {
        stateFeed = electricalFeed;
      }
      return stateFeed;
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    async activeConfig() {
      await this.openModal();
      if (this.dataNotifications) {
        document.getElementById('eventName0').checked = true;
        this.displayEmailsForEvent(this.dataNotifications[0]);
      }
    },
    openModal() {
      this.$bvModal.show('config-modal');
    },
    closeModalEdit(id) {
      this.$bvModal.hide(id);
    },
    closeModal(id) {
      this.emailsEvents = null;
      this.$bvModal.hide(id);
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    signalLost(dateSignal) {
      if (dateSignal != '-') {
        let today = Date.now();
        let daysLeft = 172800000; //2 dias
        if (dateSignal >= today - daysLeft) {
          return 'color: #6cd15a';
        } else {
          return 'color: #dc3444';
        }
      }
    },
    autoRefresh() {
      if (this.$route.name !== 'Route events') {
        return;
      }
      if (this.autoRefreshTimer !== this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        this.autoRefreshTimer = 0;
        this.prepareData();
        this.autoRefresh();
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  computed: {
    emailsNotification() {
      const common = {
        thClass: 'text-center',
      };
      return [
        {
          key: 'email',
          tdClass: 'text-center',
          label: this.$t('routeEvents.modal.emailTable.email'),
          ...common,
        },
        {
          key: 'actions',
          tdClass: 'text-center',
          label: this.$t('routeEvents.modal.emailTable.actions'),
          ...common,
        },
      ];
    },
  },
  watch: {
    '$store.getters.isUserReady': function () {
      this.prepareData();
    },
    '$store.getters.newEvent': function () {
      if (this.$store.getters.newEvent != null) {
        let event = this.$store.getters.newEvent;
        this.prepareRealData(event);
        this.$store.commit('saveNewEvent', null);
      }
    },
  },
};
